import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'montant',
  standalone: true,
})
export class MontantPipe implements PipeTransform {
  /**
   * Transforms a given numeric value into a formatted string with optional currency symbol.
   *
   * The function formats the number using French locale, inserting spaces as thousand separators.
   * If the number has a decimal part, it ensures two decimal places; otherwise, it shows no decimal places.
   *
   * @param value - The numeric value to format. If null or undefined, returns an empty string.
   * @param currencySymbol - An optional currency symbol to append to the formatted value.
   * @returns The formatted string representation of the number, with optional currency symbol.
   */

  transform(value: number | null | undefined, currencySymbol?: string): string {
    if (value == null || isNaN(value)) {
      return '';
    }

    // Check if the decimal part is zero
    const hasDecimalPart = !Number.isInteger(value);

    // Format the number with spaces as thousand separators
    const formattedValue = value.toLocaleString('fr-FR', {
      minimumFractionDigits: hasDecimalPart ? 2 : 0,
      maximumFractionDigits: hasDecimalPart ? 2 : 0,
    });

    // Add the currency symbol if provided
    return currencySymbol ? `${formattedValue} ${currencySymbol}` : formattedValue;
  }
}
